import { Box, ColorOptions, Image, Spacer, Text as NewText, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FlatList } from 'react-native'
import { pgScreenProductData } from '../../static/staticData'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

interface ProductsHomeSectionInterface {
  isTab: boolean
  isMobile: boolean
}

const ProductsHomeSection = ({ isTab, isMobile }: ProductsHomeSectionInterface) => {
  const { headerSize, subHeaderSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  const { navigate } = useNavigation()
  const renderProductItem = ({ item }: any) => {
    return (
      <Box pv={isMobile ? 32 : 40} w={isMobile ? '50%' : isTab ? '50%' : '25%'}>
        <Image source={item.icon} width={isMobile ? 72 : 112} height={isMobile ? 72 : 112} resizeMode="contain" />
        <Box pl={isMobile ? 12 : 24} pr={isMobile ? 16 : isTab ? 32 : 100}>
          <Text
            title={item?.headerText}
            fontSize={subHeaderSize}
            fontFamily={'jiotype-bold'}
            color={colors.HIGHLIGHT as ColorOptions}
            onPress={() => navigate(item.path)}
          />
          <Spacer size={12} />
          <Text
            title={item?.desc}
            fontSize={isMobile ? 14 : 16}
            fontFamily={'jiotype-medium'}
            color={'BLACK_21'}
            lineHeight={isMobile ? 20 : 24}
          />
        </Box>
      </Box>
    )
  }
  return (
    <Box nativeID="Products" pv={isMobile ? 72 : undefined}>
      <Box nativeID="Products">
        <NewText fontFamily="jiotype-black" fontSize={headerSize} lineHeight={isMobile ? 36 : undefined}>
          {staticStrings.pgProducts}
        </NewText>
      </Box>
      <Box {...themedStyle.productContainer}>
        <FlatList
          data={pgScreenProductData(true)}
          numColumns={isMobile ? 2 : isTab ? 2 : 4}
          showsVerticalScrollIndicator={false}
          renderItem={renderProductItem}
          key={isMobile ? 'm' : isTab ? 't' : 'd'}
          keyExtractor={(item) => item.id}
        />
      </Box>
    </Box>
  )
}

export default ProductsHomeSection
